'use strict';
var _interopRequireWildcard = require('@babel/runtime/helpers/interopRequireWildcard');
var _interopRequireDefault = require('@babel/runtime/helpers/interopRequireDefault');
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.AppRender = AppRender;
var _defineProperty2 = _interopRequireDefault(require('@babel/runtime/helpers/defineProperty'));
var _objectWithoutProperties2 = _interopRequireDefault(require('@babel/runtime/helpers/objectWithoutProperties'));
var _react = _interopRequireWildcard(require('react'));
var _gemsShared = require('@tencent/gems-shared');
var _gemsRendererCore = require('@tencent/gems-renderer-core');
var _StyleInjectHandler = require('./handlers/StyleInjectHandler');
var _actionHandler = require('./handlers/actionHandler');
var _PositionHandler = require('./handlers/PositionHandler');
var _store = require('./store');
var _IteratorContext = require('./IteratorContext');
var _HotAreas = require('./HotAreas');
var _OptionContext = require('./OptionContext');
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        if (i % 2) {
            ownKeys(Object(source), true).forEach(function(key) {
                (0, _defineProperty2.default)(target, key, source[key]);
            });
        } else if (Object.getOwnPropertyDescriptors) {
            Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
            ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
// if (typeof window === 'undefined') {
//   // 兼容 ssr 时，window 为 undefined 导致报错的情况
//   global.window = {};
// }
var IComponentItem = function(props) {
    var _instance$id;
    var meta = props.meta, global = props.global, instance = props.instance, path = props.path, injectProps = props.injectProps, hotAreas = props.hotAreas, children = props.children, withComponentAdaptor = props.withComponentAdaptor, store = props.store, eventHandlers = props.eventHandlers, restProps = (0, _objectWithoutProperties2.default)(props, [
        'meta',
        'global',
        'instance',
        'path',
        'injectProps',
        'hotAreas',
        'children',
        'withComponentAdaptor',
        'store',
        'eventHandlers', 
    ]);
    var key1 = instance.key, name1 = instance.name, _instance$component = instance.component, Component = _instance$component.component, __implementHotArea = _instance$component.__implementHotArea, position = instance.position, commonStyle = instance.commonStyle, data = instance.data, slot = instance.slot, style = instance.style;
    var emit = (0, _react.useCallback)(function(trigger, payload) {
        return (0, _gemsShared.emitCustomEvent)(instance, trigger, global, meta, payload, eventHandlers);
    }, [
        instance,
        global,
        meta,
        eventHandlers
    ]);
    var on = (0, _react.useCallback)(function(eventName, callback) {
        return (0, _gemsShared.onComponentEventAction)(instance, eventName, callback);
    }, [
        instance
    ]);
    var off = (0, _react.useCallback)(function(eventName, callback) {
        return (0, _gemsShared.offComponentEventAction)(instance, eventName, callback);
    }, [
        instance
    ]);
    var currentPath = "".concat(path, "/").concat(name1);
    var finalHotAreas = __implementHotArea ? hotAreas !== null && hotAreas !== void 0 ? hotAreas : /*#__PURE__*/ _react.default.createElement(_HotAreas.HotAreas, {
        global: global,
        meta: meta,
        instance: instance
    }) : null;
    var renderStore = (0, _store.useRenderStore)();
    var getStoreActionsByKey = (0, _react.useCallback)(function(key, iterator) {
        return renderStore.getStoreActionsByKey(key, iterator);
    }, [
        renderStore
    ]);
    var getParentSchemaStores = (0, _react.useCallback)(function(name) {
        return renderStore.getParentSchemaStores(instance, name);
    }, [
        renderStore,
        instance
    ]);
    var compProps = _objectSpread(_objectSpread(_objectSpread({}, restProps), injectProps), {}, {
        // TODO[V] 后续vue adaptor去掉这个属性
        injectProps: injectProps,
        // from props
        meta: meta,
        global: global,
        hotAreas: finalHotAreas,
        store: store,
        // from instance
        name: name1,
        key: key1,
        data: data,
        slot: slot,
        style: style,
        commonStyle: commonStyle,
        componentKey: key1,
        emit: emit,
        on: on,
        off: off,
        path: currentPath,
        getStoreActionsByKey: getStoreActionsByKey,
        getParentSchemaStores: getParentSchemaStores
    }); // TODO id 和 name 的兼容应该在更前置的流程更显式地处理
    // vision 旧协议里没有 name 字段，gems 新协议里没有 id 字段，这里做兼容
    var componentId = (_instance$id = instance.id) !== null && _instance$id !== void 0 ? _instance$id : instance.name;
    var WrappedComponent = withComponentAdaptor ? (0, _gemsShared.wrapHocOnce)("WrappedComponent_".concat(componentId), Component, withComponentAdaptor) : Component;
    var content = /*#__PURE__*/ _react.default.createElement(WrappedComponent, Object.assign({}, compProps, {
        instance: instance
    }), children);
    var positionContent = position ? /*#__PURE__*/ _react.default.createElement(_PositionHandler.PositionHandler, {
        positionStyle: position,
        instance: instance
    }, content) : content;
    return(/*#__PURE__*/ _react.default.createElement(_StyleInjectHandler.StyleInjectHandler, {
        instance: instance,
        scope: (0, _gemsShared.getComponentId)(instance.key)
    }, /*#__PURE__*/ _react.default.createElement(_actionHandler.ComponentActionHandler, {
        instance: instance,
        meta: meta,
        global: global
    }, positionContent)));
};
var ComponentItem = /*#__PURE__*/ (0, _react.memo)(IComponentItem, function(prevProps, nextProps) {
    var isEqual = _gemsRendererCore.memoCompare.compare(prevProps, nextProps, [
        /^instance$/,
        /^instance\.data(?:\..*)?$/,
        /^instance\.commonStyle(?:\..*)?$/,
        /^instance\.wrapperStyle(?:\..*)?$/,
        /^instance\.actions(?:\..*)?$/,
        /^store(?:\..*)?$/
    ]);
    return isEqual;
});
var useExpressionData = function(instance, global, parseExpression) {
    var _useRenderStore = (0, _store.useRenderStore)(), rootStore = _useRenderStore.rootStore;
    var iterator = (0, _react.useContext)(_IteratorContext.IteratorContext);
    var key = instance.key, data = instance.data, actions = instance.actions;
    var schemaHandlerParams = {
        rootStore: rootStore,
        global: global,
        storeId: key,
        parseExpression: parseExpression,
        iterator: iterator
    }; // 拿到解析之后的data以及相关联的storeId
    var _handleSchema = (0, _gemsRendererCore.handleSchema)(data, schemaHandlerParams), newData = _handleSchema.data, relativeStoreIds = _handleSchema.storeIds;
    var newActions = actions.map(function(action) {
        var _handleSchema2 = (0, _gemsRendererCore.handleSchema)(action.data, schemaHandlerParams), newActionData = _handleSchema2.data, actionRelativeIds = _handleSchema2.storeIds;
        relativeStoreIds = relativeStoreIds.concat(actionRelativeIds);
        return _objectSpread(_objectSpread({}, action), {}, {
            data: newActionData
        });
    }); // 拿到组件的store的state以及action
    var schemaStore = (0, _store.useSchemaStore)(relativeStoreIds, instance, iterator);
    var newInstance = _objectSpread(_objectSpread({}, instance), {}, {
        iterator: iterator,
        data: newData,
        actions: newActions
    });
    return {
        instance: newInstance,
        schemaStore: schemaStore
    };
};
var listenPageCloseEvent = function(param) {
    var global = param.global, meta = param.meta;
    var start = new Date().getTime();
    window.addEventListener('beforeunload', function() {
        var end = new Date().getTime(); // 监听关闭事件并计算浏览时长
        (0, _gemsShared.emitPage)(_gemsShared.PageEventListenerTypes.CLOSE, {
            global: global,
            meta: meta,
            addition: {
                visitDuration: end - start
            }
        });
    });
};
var emptyChildren = [];
var RenderComponent = function(props) {
    var instance = props.instance, renderHoc = props.renderHoc, meta = props.meta, path = props.path, global = props.global, parseExpression = props.parseExpression, withComponentAdaptor = props.withComponentAdaptor, disableStore = props.disableStore;
    var newInstance = instance;
    var schemaStore = null;
    var result = useExpressionData(instance, global, parseExpression);
    if (!disableStore) {
        newInstance = result.instance;
        schemaStore = result.schemaStore;
    }
    var WrappedComponentItem = renderHoc ? (0, _gemsShared.wrapHocOnce)('WrappedComponentItem', ComponentItem, renderHoc) : ComponentItem;
    var itemProps = _objectSpread(_objectSpread({}, props), {}, {
        instance: newInstance,
        store: schemaStore
    });
    var children1 = (0, _react.useMemo)(function() {
        var children = instance.children, name = instance.name;
        var p = "".concat(path, "/").concat(name);
        return children !== null && children !== void 0 && children.length ? children === null || children === void 0 ? void 0 : children.map(function(childInstance, childIndex) {
            /*#__PURE__*/ return _react.default.createElement(RenderComponent, {
                path: p,
                meta: meta,
                global: global,
                index: childIndex,
                renderHoc: renderHoc,
                key: childInstance.key,
                instance: _objectSpread(_objectSpread({}, childInstance), {}, {
                    parent: result.instance
                }),
                slot: childInstance.slot,
                parseExpression: parseExpression,
                withComponentAdaptor: withComponentAdaptor,
                disableStore: disableStore
            });
        }) : emptyChildren;
    }, [
        disableStore,
        global,
        instance,
        meta,
        parseExpression,
        path,
        renderHoc,
        withComponentAdaptor
    ]);
    return(/*#__PURE__*/ _react.default.createElement(WrappedComponentItem, itemProps, children1));
};
function AppRender(props) {
    var componentInstances = props.componentInstances, pluginInstances = props.pluginInstances;
    var optionContext = (0, _react.useContext)(_OptionContext.OptionContext);
    var meta = optionContext.meta, global = optionContext.global;
    var execPlugins = _react.default.useCallback(function() {
        pluginInstances.forEach(function(plugin) {
            var pluginFn = plugin.plugin.plugin;
            var params = (0, _gemsShared.generatePluginParams)(plugin, global, meta);
            pluginFn(params);
        });
    }, []);
    _react.default.useEffect(function() {
        execPlugins();
        (0, _gemsShared.emitPage)(_gemsShared.PageEventListenerTypes.INIT, {
            global: global,
            meta: meta
        });
        listenPageCloseEvent({
            global: global,
            meta: meta
        });
    }, []);
    return(/*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, componentInstances.map(function(instance, index) {
        /*#__PURE__*/ return _react.default.createElement(RenderComponent, Object.assign({
            path: '',
            index: index,
            key: instance.key,
            instance: instance
        }, optionContext));
    })));
}
